import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { UpdateMultiEntityOptionsBuyEntityIDBody, EntityOptionApi } from 'api';

export const createEntityOption = createAsyncThunk(
  'entityOption/create',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityOptionApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiEntityOptionsBuyEntityID = createAsyncThunk(
  'entityOption/updateMultiEntityOptionsBuyEntityID',
  async (
    body: UpdateMultiEntityOptionsBuyEntityIDBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityOptionApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityOption = createAsyncThunk(
  'entityOption/update',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityOptionApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityOption = createAsyncThunk(
  'entityOption/remove',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityOptionApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const entityOptionSlice = createSlice({
  name: 'entityOption',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: entityOptionReducer } = entityOptionSlice;

export default entityOptionReducer;
